import { isAxiosError } from 'axios';
import StatusCode from 'status-code-enum';

import { error as createError } from './Result';

export type ValidationErrorResponse = {
  code: number;
  field: string;
  message: string;
}[];

export const ERROR_TYPES = {
  UNKNOWN: 'UNKNOWN',
  NOT_FOUND: 'NOT_FOUND',
  VALIDATION: 'VALIDATION',
};

type ErrorType = (typeof ERROR_TYPES)[keyof typeof ERROR_TYPES];

export type ValidationError = {
  code: number;
  field: string;
  message: string;
}[];

export type ResponseError = {
  type: ErrorType;
  error: Error | ValidationError;
};

export const isNotFoundError = (status: number) =>
  status === StatusCode.ClientErrorNotFound;
export const isValidationError = (status: number) =>
  status === StatusCode.ClientErrorUnprocessableEntity;

export const handleValidationError = (error: unknown, message: string) => {
  if (
    isAxiosError(error) &&
    error.status === StatusCode.ClientErrorUnprocessableEntity
  ) {
    return createError(<ResponseError>{
      type: ERROR_TYPES.VALIDATION,
      error: error.response?.data,
    });
  } else {
    return createError({
      type: ERROR_TYPES.UNKNOWN,
      error: formatError(error, message),
    });
  }
};

export const formatError = (error: unknown, message: string) => {
  if (error instanceof Error) {
    return error;
  } else {
    return {
      name: 'Error',
      message,
    };
  }
};

export const getStatusCode = (
  code: string | undefined,
): StatusCode | 'default' => {
  if (!code) return 'default';
  const statusCode = Number.parseInt(code);
  if (Number.isNaN(statusCode)) return 'default';
  return statusCode as StatusCode;
};
